/*
 * Zgoda na Regulamin w koszyku (blueirys.pl).
 *
 * ZASADA: przycisk kasy zostaje AKTYWNY i wyglada normalnie.
 * Klikniecie bez zaznaczonej zgody nie przepuszcza do kasy,
 * tylko pokazuje czerwony komunikat przy checkboxie.
 * Poprzednia wersja wygaszala przycisk (opacity 0.45 + pointer-events:none),
 * przez co czytal sie jako zepsuty albo wyprzedany. Nie wracac do tego.
 *
 * DLACZEGO LISTENER JEST NA window, NIE NA document:
 * aplikacja InPost podmienia przycisk kasy na wlasny
 * ([data-inpost-checkout-proxy]) i rejestruje na window listener
 * w fazie przechwytywania z stopImmediatePropagation(). Faza capture
 * idzie window -> document, wiec listener na document nigdy by nie dostal
 * zdarzenia. Na tym samym targecie decyduje kolejnosc rejestracji, dlatego
 * ten plik MUSI byc ladowany jako pierwszy skrypt w <head>,
 * przed {{ content_for_header }} w layout/theme.liquid. Nie przenosic go
 * na koniec <body>.
 */
(function () {
  var TERMS_URL = "/pages/regulamin";
  var PRIVACY_URL = "/pages/polityka-prywatnosci";
  var ERROR_TEXT = "Zaznacz akceptację Regulaminu sklepu, żeby przejść do płatności.";
  var CART_FORM = 'form[action*="/cart"]';
  var CHECKOUT_CONTROL = [
    '[name="checkout"]',
    "[data-inpost-checkout-proxy]",
    ".cart__checkout",
    ".additional-checkout-buttons",
    "[data-shopify-buttoncontainer]",
    ".dynamic-checkout__content",
    'a[href*="/checkout"]'
  ].join(", ");
  var counter = 0;

  function closest(el, selector) {
    for (; el && el.nodeType === 1; el = el.parentElement) {
      if (el.matches && el.matches(selector)) return el;
    }
    return null;
  }

  function buildBlock(form) {
    var id = "terms-agree-" + ++counter;

    var wrap = document.createElement("div");
    wrap.setAttribute("data-terms-agree-block", "");
    wrap.style.margin = "14px 0";
    wrap.style.fontSize = "13px";
    wrap.style.lineHeight = "1.45";
    wrap.style.textAlign = "left";

    var label = document.createElement("label");
    label.setAttribute("for", id);
    label.style.display = "flex";
    label.style.alignItems = "flex-start";
    label.style.gap = "9px";
    label.style.cursor = "pointer";
    label.style.margin = "0";

    var input = document.createElement("input");
    input.type = "checkbox";
    input.id = id;
    input.name = "terms_accepted";
    input.value = "1";
    input.style.marginTop = "2px";
    input.style.flex = "0 0 auto";
    input.style.width = "16px";
    input.style.height = "16px";

    var text = document.createElement("span");
    text.innerHTML =
      'Akceptuję <a href="' + TERMS_URL + '" target="_blank" rel="noopener" style="text-decoration:underline">Regulamin sklepu</a> oraz ' +
      '<a href="' + PRIVACY_URL + '" target="_blank" rel="noopener" style="text-decoration:underline">Politykę prywatności</a>.';

    label.appendChild(input);
    label.appendChild(text);

    var error = document.createElement("div");
    error.setAttribute("data-terms-agree-error", "");
    error.setAttribute("role", "alert");
    error.textContent = ERROR_TEXT;
    error.style.display = "none";
    error.style.marginTop = "6px";
    error.style.color = "#c0392b";

    wrap.appendChild(label);
    wrap.appendChild(error);

    function show() {
      error.style.display = "block";
      try {
        wrap.scrollIntoView({ block: "nearest" });
      } catch (e) {}
      try {
        input.focus({ preventScroll: true });
      } catch (e) {
        input.focus();
      }
    }

    input.addEventListener("change", function () {
      if (input.checked) error.style.display = "none";
    });

    form.__termsAgree = { form: form, input: input, show: show };
    return wrap;
  }

  function init() {
    var forms = document.querySelectorAll(CART_FORM);
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      var button = form.querySelector('[name="checkout"], [data-inpost-checkout-proxy], .cart__checkout');
      if (!button) continue;
      if (form.hasAttribute("data-terms-agree-ready")) continue;
      form.setAttribute("data-terms-agree-ready", "");

      var block = buildBlock(form);
      var anchor = button;
      var extraBlock = form.querySelector(".additional-checkout-buttons, [data-shopify-buttoncontainer]");
      if (extraBlock && extraBlock.compareDocumentPosition(button) & Node.DOCUMENT_POSITION_FOLLOWING) {
        anchor = extraBlock;
      }
      if (anchor.parentNode) anchor.parentNode.insertBefore(block, anchor);
    }
  }

  function block(e, form) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    form.__termsAgree.show();
  }

  function onClick(e) {
    var control = closest(e.target, CHECKOUT_CONTROL);
    if (!control) return;
    var form = closest(control, CART_FORM);
    if (!form || !form.__termsAgree || form.__termsAgree.input.checked) return;
    block(e, form);
  }

  function onSubmit(e) {
    var form = closest(e.target, CART_FORM);
    if (!form || !form.__termsAgree || form.__termsAgree.input.checked) return;
    if (e.submitter && !closest(e.submitter, CHECKOUT_CONTROL)) return;
    block(e, form);
  }

  // window + capture, zarejestrowane jako pierwsze. Patrz komentarz na gorze.
  window.addEventListener("click", onClick, true);
  window.addEventListener("submit", onSubmit, true);
  // Zapas, gdyby ktores zdarzenie nie doszlo do window.
  document.addEventListener("click", onClick, true);
  document.addEventListener("submit", onSubmit, true);

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    init();
    var pending = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        init();
      }, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("cart:updated", init);
    document.addEventListener("cart:build", init);
  });
})();
